<template>
  <div class="wrap" @click="toggleTheme">
    <span class="icon icon-light" v-show="theme == 'light'"></span>
    <span class="icon icon-dark" v-show="theme == 'dark'"></span>
  </div>
</template>

<script>
const key = "THEME";
import { themeState, setTheme } from "@/utils/theme";

export default {
  data() {
    return {
      themeState,
    };
  },
  computed: {
    theme() {
      return this.themeState.theme;
    },
  },
  created() {
    setTheme(this.theme);
  },
  methods: {
    toggleTheme() {
      const newTheme = this.theme === "light" ? "dark" : "light";
      setTheme(newTheme);
    },
  },
};
</script>

<style scoped lang="less">
.wrap {
  width: 25px;
  height: 25px;
  border-radius: 4px;

  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  top: -2px;

  &:hover {
    background-color: rgba(0, 0, 0, 0.1);
  }
}

.icon {
  width: 16px;
  height: 16px;
  display: inline-block;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  cursor: pointer;
}

.icon-light {
  background-image: url("../assets/icon/light.svg");
}

.icon-dark {
  background-image: url("../assets/icon/dark.svg");
}
</style>
